import { IFont } from '../plan-primitive';
import { SHEET_TITLE_FONT } from '../sheet-layout';
import { ITextMeasurer } from '../text-measurer';
import { textWidth } from './dxf-entities';
import { PAPER_MM_PER_PX } from './dxf-fit';
import { DXF_TITLE_TEXT_MM } from './dxf-model-layout';
import { DXF_LABEL_TEXT_MM, LARGE_FONT_MIN_PX } from './dxf-primitives';
import { toDxfText } from './dxf-text';

/**
 * The text measurer the writer lays its sheet out with: a label measures what it will take in
 * the file — its DXF text, in Arial, at the ГОСТ height the writer gives its font — in sheet
 * pixels. The sheet then keeps labels apart and sizes title rows for the file's own text, which
 * is larger than the screen's. Deterministic: no canvas, no installed fonts.
 */
export const dxfTextMeasurer: ITextMeasurer = {
    measure(text: string, font: IFont): number {
        // A view title is set larger than any label; the sheet measures its title row with this font.
        const large: boolean = font === SHEET_TITLE_FONT || font.size >= LARGE_FONT_MIN_PX;
        const height: number = large ? DXF_TITLE_TEXT_MM : DXF_LABEL_TEXT_MM;
        return textWidth(toDxfText(text), height) / PAPER_MM_PER_PX;
    },
};
